import React, { Component } from 'react';
import LinkButton from '../LinkButton';

export class Freight extends Component {
    static displayName = Freight.name;

    constructor(props) {
        super(props);
        this.state = { data: [], loading: true };
        this.history = props.history;
    }

    componentDidMount() {
    }
    goto(page) {
        this.history.push(page);
    }

    render() {
        return <div className="container" >
     
            <div className="row mb-3 ">
                <LinkButton className="btn btn-success col-12 mb-2" to="Manifesting" >Manifesting</LinkButton>
            </div>
        
        </div>
    }


}
